export default function (context, val) {
    let form = context.state;
    form.dateType = val.dateType;
    form.CurrencyId = val.CurrencyId;
    form.InvoiceSumFrom = val.InvoiceSumFrom;
    form.InvoiceSumTo = val.InvoiceSumTo;
    form.PayStates = val.PayStates;
    form.PaymentOperationId = val.PaymentOperationId;
    form.CategoryId = val.CategoryId;
    form.PaymentTypeIds = val.PaymentTypeIds;
    form.CashList = val.CashList;
    form.PaymentAccountList = val.PaymentAccountList;
    form.ContragentId = val.ContragentId;
    form.ContragentName = val.ContragentName;
    form.ContragentSearchTypeId = val.ContragentSearchTypeId;
    form.ManagerList = val.ManagerList;
    form.DepartmentList = val.DepartmentList;
    form.OnlyOverdue = val.OnlyOverdue;
    form.KindOfPayId = val.KindOfPayId;
    form.AccountNumber = val.AccountNumber;
    form.AgreementCode = val.AgreementCode;

    let dFrom = new Date(), dTo = new Date();
    switch (val.dateStep) {
        case 1:
            dFrom.setDate(dFrom.getDate() - val.dateInt);
            break;
        case 2:
            dFrom.setDate(dFrom.getDate() - val.dateInt * 7);
            break;
        case 3:
            dFrom.setMonth(dFrom.getMonth() - val.dateInt);
            if (val.dateRound) {
                // dFrom.setMonth(dFrom.getMonth());
                dFrom.setDate(1);
            }
            break;
    }

    form.dates = [
        '' + (dFrom.getDate() > 9 ? '' : '0') + dFrom.getDate() + '.' + (dFrom.getMonth() > 8 ? '' : '0') + (dFrom.getMonth() + 1) + '.' + dFrom.getFullYear(),
        '' + (dTo.getDate() > 9 ? '' : '0') + dTo.getDate() + '.' + (dTo.getMonth() > 8 ? '' : '0') + (dTo.getMonth() + 1) + '.' + dTo.getFullYear()
    ];
    if (val.searchClick) {
        context.dispatch('finances/invoices/search', null, {root: true});
    }
}